import axios from 'axios';
import config from '../config';

/**
 * send an account verification email.
 *
 * @param {string} email - user's email
 *
 * @return {object} - A success response object https://api.luxtag.io:8443/apidoc/#api-User-ResendConfirm
 */
function accountVerification(email) {
  if (arguments.length < 1 || email === '') {
    throw new Error('Email is missing in accountVerification email request!');
  } else {
    return axios({
      method: 'post',
      url: `/users/resend-confirm/${email}`,
      baseURL: config.host,
      timeout: 50000,
      data: {
        access_token: config.key,
      },
    });
  }
}

export default {
  accountVerification: accountVerification,
};



// WEBPACK FOOTER //
// ./src/API/Email/email.js